import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openid: "",
    userInfo: {}
  },
  mutations: {
    setUserInfo(state,userInfo){
      state.userInfo=userInfo;
      localStorage.setItem('userInfo',JSON.stringify(userInfo))
    },
    setOpenid(state,openid){
      state.openid=openid;
      localStorage.setItem('openid',openid)
    }
  },
  actions: {
  },
  modules: {
  }
})
